import { defineFetch } from 'resift';

export interface CreateRolePermissionRequest {
  permissionId: string;
  scopeFilter?: any;
}

const makeCreatePermissionForRole = defineFetch({
  displayName: 'Create Permission for Role',
  make: roleId => ({
    request: (data: CreateRolePermissionRequest) => ({ http }) =>
      http({
        method: 'POST',
        route: `/roles/${roleId}/permissions`,
        data,
      }),
  }),
});

export default makeCreatePermissionForRole;
